import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@ui/components/ui/dialog';
import Button from '@ui/components/ui/loading-button';

export interface AlertPopUpProps extends React.HTMLAttributes<HTMLDivElement> {
  handleClick: () => void;
}

const AlertPopUp = ({ handleClick }: AlertPopUpProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <Dialog open onOpenChange={open => !open && handleClick()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('alerts.allowPopups')}</DialogTitle>
        </DialogHeader>
        <Button
          variant="contained"
          color="primary"
          className="mx-auto mt-10 block w-fit text-center"
          onClick={() => window.location.reload()}
        >
          {t('actions.reloadPage')}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default AlertPopUp;
